import { useProcessInstance } from 'exacta-material-react/lib/src/hooks';
import QueryString from 'query-string';
import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import LoadingProgress from '../../components/LoadingProgess';
import { getLessonDefinition, getResourcesForLesson } from '../../store/actions/resources.actions';
import { RESOURCE_LOADED_STATUS } from '../../store/sagas/resources.saga';
import Catiz3 from '../Catiz3';
import CatizTouchPanel from '../Catiz3/TouchPanel';
import Hermesys from '../Hermesys';
import { HermsysMain } from '../Hermesys/main';
import S80 from '../S80';

const LessonLauncherOnline: React.FC = () => {
    const resourcesLoadingStatus = useSelector((state: any) => state.resources.loadingStatus);
    const location = useLocation();
    const { unit, version, system, subsystem } = QueryString.parse(location.search);
    const dispatch = useDispatch();
    const executorResources = useSelector((state: any) => state.resources);
    const trainingUnit = useProcessInstance(unit, 'Lesson');
    const { t } = useTranslation();
    const lessonDef = executorResources.lessonDefinition;

    useEffect(() => {
        if (!lessonDef && trainingUnit && version) {
            dispatch(getLessonDefinition({ trainingUnit, version }));
        }
    }, [trainingUnit, version]);

    useEffect(() => {
        if (lessonDef) {
            dispatch(getResourcesForLesson({
                resources: lessonDef.requiredComponents,
                lessonId: lessonDef.id,
            }));
        }
    }, [lessonDef]);

    if (!lessonDef || !resourcesLoadingStatus[lessonDef.id]) {
        return <LoadingProgress message={t('loadingProgress.player')} />;
    }
    if (resourcesLoadingStatus[lessonDef.id] === RESOURCE_LOADED_STATUS.FAILED) {
        return <p>Failed loading resources</p>;
    }
    return (
        <Fragment>
            {system === 's80' && <S80 />}
            {system === 'catiz3' && subsystem === 'touchpanel' && <CatizTouchPanel />}
            {system === 'catiz3' && subsystem !== 'touchpanel' && <Catiz3 />}
            {system === 'hermesys' && <Hermesys />}
        </Fragment>
    );
};

export default LessonLauncherOnline;
